import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=08a23a12&scoped=true&"
import script from "./CompanyHeader.vue?vue&type=script&lang=js&"
export * from "./CompanyHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=08a23a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a23a12",
  null
  
)

export default component.exports